<mat-checkbox class="mat-option" [indeterminate]="isIndeterminate()" [checked]="isChecked()" (click)="$event.stopPropagation()"
              (change)="toggleSelection($event)">
    <span class="font-bold col-blue">{{text}}</span>
</mat-checkbox>
